import { createTestId } from 'utils';
import React, { useState, useEffect, useContext, useRef } from "react"
import { useSelector } from "react-redux";
import * as Icon from "react-feather"
import { useNavigate } from 'react-router-dom'
import { AppContext } from 'configuration/app-context'
import WebClient, { constants } from 'utils/webclient'
import * as ApiService from 'utils/api-service'

import { IconButton } from "components/button"

import { Formik } from "formik"
import * as Yup from "yup"
import CustomSelect from "components/form-inputs/Select";
import IBigSpinner from "components/spinner/big-spinner";
import ISpinner from "components/spinner/spinner";
import DefaultHeroImage from "assets/img/default-hero-image.png" 

const DepartmentDetail = (props) => {

    console.log("DepartmentDetail-->", props)

    const navigate = useNavigate()
    const formikRef = useRef(null)

    const { translate, showDialog } = useContext(AppContext)
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hospitals, setHospitals] = useState([])
    const [appointmentTypes, setAppointmentTypes ] = useState([])
    const [departmentId, setDepartmentId] = useState()
    const [insuranceCompanies, setInsuranceCompanies] = useState([])
    const [isShowForm, setIsShowForm] = useState(true)

    function GetDetail(departmentId = 0, departmentCode, hospitalId) {
        let c = new WebClient();
        c.post("573D6FBC30D637/FindDepartment", {
            departmentId, departmentCode, hospitalId
        }, false, false, false)
            .then(({ isSuccess, exception, data, count }) => {
                if (isSuccess) {
                    setDetail(data)
                    setDepartmentId(data.id)
                    GetInsuranceCompany(props.hospitalId, data.id)
                    AppointmentTypeList(props.hospitalId, data.id)
                }
            })
    }

    useEffect(() => {
        GetDetail(props?.id, props.code, props.hospitalId)
    }, []);

    const GetInsuranceCompany = (hospitalId, departmentId ) => {
        let c = new WebClient();
        c.post("573D6FBC30D637/InsuranceCompanyList", { hospitalId, departmentId })
            .then(({ isSuccess, exception, data }) => {
                if (isSuccess) {

                    let insurance_companies = data.map((e) => {
                        return {
                            value: e.id,
                            label: e.name
                        }
                    })
                    let _insurance_companies = [{ value: 0, label: translate("continue_without_select") }, ...insurance_companies]
                    setInsuranceCompanies(_insurance_companies)
                    if(insurance_companies.length === 0 && appointmentTypes.length > 0 && isShowForm){
                        console.log("formikRef-->", formikRef.current)
                        formikRef.current.setFieldValue("insuranceCompany", _insurance_companies[0])
                    } 
                }
            })
    }

    const AppointmentTypeList = (hospitalId, departmentId) => {
        setLoading(true)
        let c = new WebClient();
        c.post("573D6FBC30D637/FilterAppointmentTypes", {
            hospitalId: hospitalId,
            departmentId: departmentId,
            codes: [constants.appointmentTypesCode.physical, constants.appointmentTypesCode.online, constants.appointmentTypesCode.tyto, constants.appointmentTypesCode.radiology]
        }, true)
        .then(({ isSuccess, exception, data }) => {
            if (isSuccess) {
                let a = data.map((e) => {
                    return {
                        ...e,
                        value: e.id,
                        label: e.name
                    }
                })
                setAppointmentTypes(a)
                const _isShowForm = data.filter(e => e.usedInRadiologyAppointmentRequests == true).length > 0 ? false : true
                setIsShowForm(_isShowForm)
                if (a.length == 1 && _isShowForm) {
                    GetHospitals(a[0].value, departmentId)
                }
            }
            setLoading(false)
        })
    }      

    async function GetHospitals(appointmentTypeId, departmentId) {
        setLoading(true)
        await ApiService.FilterHospitalsByAppointmentType({
            appointmentTypeId: appointmentTypeId,
            departmentId: departmentId
        }).then((a) => {
                setHospitals(a)
                if (a.length == 1) {
                    console.log("-->")
                    formikRef.current.setFieldValue("hospital", a[0])
                }
                setLoading(false)
            })
    }      

    if (detail == null) return (
        <div className="w-full h-64 flex items-center justify-center">
            <IBigSpinner size="sm" />
        </div>
    )

    return (
        <>
        <div className="hero">
            <div className="hero-image">
                <img src={detail?.image ? detail.image : DefaultHeroImage}  alt={detail?.name}/>
            </div>
        </div>
        <div className="flex flex-row items-center justify-center gap-4 mb-4">
            <IconButton
                className="custom-shadow"
                label={translate("doctors")}
                data-testid={createTestId('iconbutton', 'DepartmentDetail', 1)} onClick={() => {
                    navigate('/doctors', { state: { hospitalId: detail.hospitalId, departmentId: detail.id } })
                }}>
                <Icon.List size={16} className="text-secondary-700" />
            </IconButton>

            <IconButton
                className="custom-shadow"
                label={translate("hospitals")}
                data-testid={createTestId('iconbutton', 'DepartmentDetail', 2)} onClick={() => {
                    navigate('/hospitals', { state: { departmentCode: detail.code } })
                }}>
                <Icon.Filter size={16} className="text-secondary-700" />
            </IconButton>

        </div>
        <div>
            <h1 className="text-primary-800 text-center font-medium">{detail.name}</h1>
            <p className="text-primary-800 text-center text-sm">{detail.hospital}</p>
            <hr className="my-4" />
            <div className="mb-4">
                {detail.resources?.detail}
            </div>
            {
                    (appointmentTypes.length > 0 && isShowForm) && (
                        <Formik
                        innerRef={formikRef}
                        initialValues={{
                            insuranceCompany: insuranceCompanies.length === 1 ? insuranceCompanies[0] : "",
                            appointmentType: appointmentTypes.length == 1 ? appointmentTypes[0] : "",
                            hospital: hospitals.length == 1 ? hospitals[0] : ""
                        }}
                        validationSchema={Yup.object().shape({
                            insuranceCompany: Yup.object().required(translate("validation_message_empty_insurance_company")),
                            appointmentType: Yup.object().required(translate("validation_message_empty_appointment_type")),
                            hospital: Yup.object().required(translate("validation_message_empty_hospital"))
                        })}
                        onSubmit={(values, { setSubmitting, resetForm, setError, setFieldValue }) => {
                            navigate("/appointment", {
                                state: {
                                    pre: {
                                        packageGrade: 0,
                                        packageGradeService: 0,
                                        appointmentTypeId: values.appointmentType.value, 
                                        hospital: values.hospital.value,
                                        department: detail.id,
                                        insurance: values.insuranceCompany.value
                                    }
                                }
                            })
                        }}
                    >
                        {({ errors, touched, values, isSubmitting, handleChange, handleSubmit, setValues, handleBlur, setFieldValue, submitForm, resetForm, setErrors }) => (
                        <>

                       
                        <CustomSelect
                        label={translate("label_insurance_company")}
                        placeholder={loading ? translate("loading") : translate("placeholder_insurance_company")}
                        value={values.insuranceCompany}
                        name="insuranceCompany"
                        options={insuranceCompanies}
                        isSearchable={true}
                        onChange={(e) => { 
                            setValues({
                                insuranceCompany: e,
                                appointmentType: "",
                                hospital: ""
                            })
                        }}
                        /> 
                      
                
                        {(values?.insuranceCompany) && (
                        <CustomSelect
                            label={translate("label_appointment_type")}
                            placeholder={loading ? translate("loading") : translate("placeholder_appointment_type")}
                            value={values.appointmentType}
                            name="appointmentType"
                            options={appointmentTypes}
                            showErrorLabel={true}
                            error={touched.appointmentType && errors.appointmentType ? errors.appointmentType : ""}
                            isSearchable={true}
                            onChange={(e) => { 
                                setValues({
                                    ...values,
                                    appointmentType: e,
                                    hospital: ""
                                })
                                GetHospitals(e.value, departmentId)
                            }}
                        /> 
                        )}

                        {
                        (values?.appointmentType) && (
                        <CustomSelect
                            label={translate("label_hospital")}
                            placeholder={loading ? translate("loading") : translate("placeholder_hospital")}
                            value={values.hospital}
                            name="hospital"
                            options={hospitals}
                            showErrorLabel={true}
                            error={touched.hospital && errors.hospital ? errors.hospital : ""}
                            isSearchable={true}
                            onChange={(e) => { 
                                setFieldValue("hospital", e)
                            }}
                        />                 
                        )
                        }   
        
                        <button 
                            disabled={isSubmitting || loading}
                            data-testid={createTestId('button', 'DepartmentDetail', 3)} onClick={() => handleSubmit()}
                            className="btn btn-gradient-primary mx-auto lg:mt-auto disabled:opacity-40">
                            {(isSubmitting || loading) ? <ISpinner /> : translate("make_appointment")}
                        </button>
                        </>
                        )}
                        </Formik> 
                    )    
            }

            {
                detail?.radiologyAppointmentRequest?.available && (
                    <button 
                        data-testid={createTestId('button', 'DepartmentDetail', 4)} onClick={() => {
                            if(detail?.radiologyAppointmentRequest?.isActive){
                                navigate("/appointment-request", {
                                    state: {
                                        pre: {
                                            hospital: {
                                                value: detail.hospitalId,
                                                label: detail.hospital
                                            },
                                            department: {
                                                value: detail.id,
                                                label: detail.resource.name
                                            },
                                            from: "department",
                                            appointmentTypeId: appointmentTypes.filter(e => e.usedInRadiologyAppointmentRequests == true) > 0 ? appointmentTypes.filter(e => e.usedInRadiologyAppointmentRequests == true)[0].value : 0,
                                        }
                                    }
                                })
                            } else {
                                showDialog(
                                    translate("warning"),
                                    detail?.radiologyAppointmentRequest?.warningMessage,
                                    "warning",
                                    false,
                                    translate("ok"),
                                    () => {
                                    }
                                )
                            }
                        }}
                        className="btn btn-gradient-primary mx-auto lg:mt-auto disabled:opacity-40">
                        {translate("create_an_appointment_request")}
                    </button>
                )
            }

        </div>
        </>
    )
}

export default DepartmentDetail